/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registrations_SidebarInputs */

const en_admin_registrations_sidebar = /** @type {(inputs: Admin_Registrations_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrations`)
};

const de_admin_registrations_sidebar = /** @type {(inputs: Admin_Registrations_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierungen`)
};

/**
* | output |
* | --- |
* | "Registrations" |
*
* @param {Admin_Registrations_SidebarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registrations_sidebar = /** @type {((inputs?: Admin_Registrations_SidebarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registrations_SidebarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registrations_sidebar(inputs)
	return en_admin_registrations_sidebar(inputs)
});